import { deriveSlideTextSubject } from "../outline/outlineSlide.js";
/** Slide title + bullets + layer text for stale detection. */
export function slideContentSummary(slide, deck) {
    const outline = deck.outline?.find((s) => s.id === slide.outlineSectionId);
    const title = slide.layers.find((l) => l.type === "text" && l.textRole === "title")?.content?.trim() ??
        outline?.title ??
        "";
    const bullets = slide.layers
        .filter((l) => l.type === "text" && l.textRole === "bullet")
        .map((l) => l.content.trim())
        .filter(Boolean);
    const outlineBullets = outline?.bullets ?? [];
    const subject = deriveSlideTextSubject(slide);
    return [title, ...bullets, ...outlineBullets, subject].filter(Boolean).join("\n");
}
/** Simple deterministic hash for stale detection (not cryptographic). */
function fnv1a(str) {
    let hash = 0x811c9dc5;
    for (let i = 0; i < str.length; i += 1) {
        hash ^= str.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16).padStart(8, "0");
}
/** Hash slide text layers + title + outline bullets → stale detection. */
export function slideTextHash(slide, deck) {
    return fnv1a(slideContentSummary(slide, deck));
}
